/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Integrations_Apis_Linked_ProjectsInputs */



/**
* | output |
* | --- |
* | "Linked to {count} projects." |
*
* @param {Integrations_Apis_Linked_ProjectsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_apis_linked_projects = /** @type {((inputs: Integrations_Apis_Linked_ProjectsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Apis_Linked_ProjectsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Mit ${i?.count} Projekten verknüpft.`)
	return /** @type {LocalizedString} */ (`Linked to ${i?.count} projects.`)
});